/**
 * LazySuspense.tsx
 * Wrapper Suspense avec fallback pour les composants lazy-loaded
 * Phase 3.1 : Optimisation des performances
 */
import React, { Suspense, ReactNode } from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface LazySuspenseProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Wrapper Suspense avec fallback par défaut
 */
export function LazySuspense({ children, fallback }: LazySuspenseProps): React.ReactElement {
  return <Suspense fallback={fallback || <LoadingSpinner />}>{children}</Suspense>;
}
